var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createDraftRoute } from '../store/state/draft/route/selectors';
import { validator } from '../store/state/draft/validators';
import { toPoint } from '../utils';
export var toInitialState = function (props) { return function () {
    var _a, _b, _c;
    if (props.initialState !== undefined) {
        return __assign(__assign({}, props.initialState), { validate: validator(props.validate) });
    }
    var publicDraft = props.initialValues, coords = props.coords;
    var route = createDraftRoute(2, publicDraft === null || publicDraft === void 0 ? void 0 : publicDraft.route);
    var zonePoint = toPoint((_c = (_b = (_a = route[0]) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.geoObject) === null || _c === void 0 ? void 0 : _c.pos) || coords;
    var async = {};
    var draft = {
        values: __assign(__assign({}, publicDraft), { route: route, coupon: '' }),
    };
    return {
        suggest: {},
        zone: {
            point: zonePoint,
        },
        async: async,
        draft: draft,
        validate: validator(props.validate),
    };
}; };
